import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiUrls } from 'src/app/api-urls.constants';

@Injectable({
  providedIn: 'root'
})
export class LoggingService {

  constructor(private http: HttpClient) { }

  logError(errorLog: ErrorLog) {
    this.http.post<ErrorLog>(ApiUrls.Administration_LogError, errorLog).subscribe();
  }
}

interface ErrorLog {
  message: string;
  stackTrace: string;
}
